
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import LazyImage from "@src/components/LazyImage";
import ListBox from "@src/components/ListBox";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import ShopInfoBox from "@src/components/ShopInfoBox";
import { murakamiMasanori } from "@src/constants/authors";
import {
  ginzaVomeroVomeroTopImage,
  ginzaVomeroPizzagamaImage,
  ginzaVomeroMarinalaImage,
} from "@src/constants/images";
export const meta = {
  path: "/media/ginza/vomero",
  title: "【こんなのあり！？】ピザ職人が作るヴォメロのピザランチが最高だった",
  description: "東銀座から徒歩3分の距離に位置する名店「ヴォメロ 」。日本屈指のピザ職人が作るピザが話題で、食べログの高評価や百名店に選べれ続けている銀座で指折りの名店です。そんなヴォメロの雰囲気、名店なのにコスパの良いランチ、おすすめメニュー、行列情報についてご紹介しています。",
  topImg: ginzaVomeroVomeroTopImage,
  author: murakamiMasanori,
  tags: ["銀座", "有名店", "おしゃれな内装", "イタリアン", "人気店", "お店の紹介", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`東銀座から徒歩 3 分に位置する名店「ヴォメロ」は、食べログの評価が高く、百名店にも毎年選ばれている日本でも指折りの名店。`}</p>
    <p>{`店内のスタッフの驚くべきコミュニケーションスタイルや、「こんなにも！？」と思うくらいのコスパの良いピザランチが特徴的です。`}</p>
    <p>{`有名店だからこその行列情報も併せてお届けしますので、是非ご覧ください。`}</p>
    <h2>{`ヴォメロとは`}</h2>
    <InstaImage postId="CC7FQKhngC2" mdxType="InstaImage" />
    <p>{`東銀座の静かな路地裏にクリーム色でひときわ賑わう一軒家のイタリアン。
`}<strong parentName="p">{`食べログの評価は 3.7`}</strong>{`を超える高評価で、その人気の噂を聞きつけて連日行列ができています。`}</p>
    <h3>{`イタリア語が飛び交う店内`}</h3>
    <InstaImage postId="BpGslXwlOsB" mdxType="InstaImage" />
    <p>{`ヴォメロの特徴はイタリアのような雰囲気を感じられること。
店員さんのご案内や、注文の共有をイタリア語で話している姿を見ることができます。銀座のイタリアンで現地の雰囲気を疑似体験できるのは貴重な体験ですよね。`}</p>
    <hr></hr>
    <h2>{`日本屈指のピザ職人が作るピザ`}</h2>
    <p>{`ヴォメロは、「真のナポリピッツア協会」認定店出身で、日本屈指のピザ職人吉武紀英が作るピザを食べることができます。
直径約 30 センチの「インパクトのあるボリューム感」と、サックリと歯切れがいい「アゴの疲れない硬さ」に気を配ってピザを作るそうです。`}</p>
    <h3>{`ナポリ由来のピザ釜`}</h3>
    <LazyImage img={ginzaVomeroPizzagamaImage} mdxType="LazyImage" />
    <p>{`ヴォメロの一階に設置されているピザ釜は、イタリアのナポリ由来で作られたピザ窯で、職人の腕だけでなく、本格的なピザを作る窯が準備されているのも特徴的。
窯の奥にメラメラと燃える炎と、ピザが焼き上がる工程を一階席だと見ることができるのが、ヴォメロに足を運びたくなる理由の一つです。`}</p>
    <hr></hr>
    <h2>{`最高のコスパランチ`}</h2>
    <InstaImage postId="B-gEPfwFPnt" mdxType="InstaImage" />
    <p>{`東銀座駅から徒歩 3 分の立地で、食べログ高評価の百名店に選ばれる店だと、ランチが 1500 円を超えることも少なくありません。
ヴォメロは、前菜、お好きなピザ一枚、食後のドリンクがついて、なんと`}<strong parentName="p">{`1,320 円`}</strong>{`でボリューム感のある絶品ランチが食べられるコスパが抜群のお店なんです。`}</p>
    <h3>{`一度は食べて欲しいマリナーラ`}</h3>
    <p>{`//marinala を挿入`}</p>
    <LazyImage img={ginzaVomeroMarinalaImage} mdxType="LazyImage" />
    <p>{`チーズなしのシンプルなピザで、本場イタリアでは王道とされるピザがマリナーラ。
ニンニク、チェリートマト、バジル、オリーブオイルが絶妙に混ざりあり、最後にオレガノが全ての香りを包み込んでくれる。
手が止まらないくらい食べれてしまう、そんなヴォメロのマリナーラにトライしてみてください。`}</p>
    <hr></hr>
    <h2>{`ランチの行列情報`}</h2>
    <p>{`人気店だからこそ、平日・休日問わずにヴォメロでは行列ができ流ことが一般的。
平均的な行列人数は 10〜20 人で、待ち時間は 15〜30 分。
実際に私がお店に行った時は、平日の 14 時で 10 人待ち、15 分ほどで入店ができました。`}</p>
    <h3>{`狙い目の時間帯はここ`}</h3>
    <p>{`並ぶのが苦手な人は、オープン前かオープン時間にお越しいただくと並ばなくて済む可能性が高いです。
並ぶのがそこまで苦手じゃない方は、10 人待ちでも 15 分程度の待ち時間で入店できるので、時間帯を気にせずお越しいただくのが良いかもしれません。`}</p>
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`銀座のピザの名店ヴォメロのコスパの良い絶品ランチについてご紹介しました。銀座でイタリアンランチを食べたい時には、ヴォメロで現地の雰囲気を体感しつつ、素敵なランチタイムを過ごしてください。`}</p>
    <ShopInfoBox shopId="bsbefpi23akg00a2m76g" mdxType="ShopInfoBox" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;